import { render } from "./AuthOvertimeDetails.vue?vue&type=template&id=22ba8543&scoped=true"
import script from "./AuthOvertimeDetails.vue?vue&type=script&lang=js"
export * from "./AuthOvertimeDetails.vue?vue&type=script&lang=js"

import "./AuthOvertimeDetails.vue?vue&type=style&index=0&id=22ba8543&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ba8543"]])

export default __exports__